import { render, staticRenderFns } from "./StoryCard.vue?vue&type=template&id=b0fe56d8&"
import script from "./StoryCard.vue?vue&type=script&lang=js&"
export * from "./StoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports